import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import PublicLessonPage from './PublicLessonPage';
import redirects from '../../content/lessons/rehomeRedirects.json';

// Client-side safety net for the retired /guide/rehoming/... guides (ticket-2517).
//
// public/_redirects already 301s all 25 of these at the edge, and that stays the
// primary mechanism — it is a real redirect, so it carries link equity and costs
// no JS. But it cannot help once a CDN node has the pre-deploy response cached:
// before the rules shipped, these paths fell through to the SPA catch-all and were
// cached as a 200 index.html with a long edge TTL. `max-age=0, must-revalidate`
// then keeps that entry alive indefinitely, because each revalidation succeeds
// against the stale copy. Two of the 25 were reported doing exactly that, serving
// "We couldn't find that lesson" while the same URLs 301'd correctly from another
// PoP.
//
// So if index.html is what gets served, finish the job in the app. Same mapping
// file the redirect generator reads, so the two cannot disagree.
const BY_PATH = new Map(redirects.map((r) => [r.from, r.to]));

export default function RetiredGuideRedirect() {
  const { slug = '' } = useParams();
  const { search, hash } = useLocation();
  const target = BY_PATH.get(`/guide/rehoming/${slug}`);

  // Preserve ?t= / ?pp= so a macro link still authenticates and still attributes.
  if (target) return <Navigate to={`${target}${search}${hash}`} replace />;

  // Not a mapped guide — let the normal page render its own not-found state
  // rather than inventing a different one.
  return <PublicLessonPage />;
}
